/**
 * Default ComponentFactory.
 * Replace this class in shared.stage.Board in order to add new type of component, and/or to customize toolbar for each component.
 */
fx.ns("shared.stage", class ComponentFactory {

  create(component, model, svg, manual) 
  {
    let componentClass, componentCommands;
    
    switch(component.component_type)
    {
          case "photo":
          case "image":
              componentClass = shared.stage.components.Photo;
              componentCommands = [];
            break;

          case "background":
              componentClass = shared.stage.components.Background;
              componentCommands = [];
            break;

          case "sticker":
              componentClass = shared.stage.components.Sticker;
              componentCommands = [];
            break;
            
          case "shape":
              componentClass = shared.stage.components.Shape;
              componentCommands = [];
            break;

          case "text":
              componentClass = shared.stage.components.Text;
              componentCommands = [];
            break;

          case "pagination":
              componentClass = shared.stage.components.Pagination;
              componentCommands = [];
            break;

            case "calendar":
                componentClass = model.creation.nonEditableCalendar ? shared.stage.components.CalendarGridSimple : shared.stage.components.CalendarGridEditable;
                componentCommands = [];
            break;
        }
              
    return componentClass ? new componentClass( component, model, svg, manual, componentCommands ) : null;
  }
});